const overlayStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 30,
  background: "rgba(30, 38, 53, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const markStyle = {
  width: 67,
  height: 64,
  display: "block",
  objectFit: "contain",
};

export default function BindingLoadingOverlay() {
  return (
    <div style={overlayStyle} role="status" aria-live="polite" aria-label="Loading">
      <style>{`
        .dd-binding-mark {
          animation: dd-binding-pulse 1.2s ease-in-out infinite;
        }
        @keyframes dd-binding-pulse {
          0%, 100% { transform: scale(1); opacity: 0.55; }
          50% { transform: scale(1.12); opacity: 1; }
        }
      `}</style>
      <img
        className="dd-binding-mark"
        src="/assets/images/direct-debit/singapay-mark.png"
        alt=""
        width={67}
        height={64}
        style={markStyle}
      />
    </div>
  );
}
